'use client'

import Link from 'next/link'
import { cn } from '~/utils/cn'
import { ClassValue } from 'clsx'
import { IconPhone } from './Icons/IconPhone'
import { useTranslation } from '~/i18n/useTranslation'

type TalkToExpertLinkProps = {
  intent?: 'primary' | 'default'
  className?: ClassValue
}

export const TalkToExpertLink = ({
  intent = 'default',
  className,
}: TalkToExpertLinkProps) => {
  const { t } = useTranslation()
  return (
    <>
      <Link
        href="https://calendly.com/taloflow/expert"
        rel="noopener noreferrer"
        target="_blank"
        className={cn(
          'rounded py-[2px] px-3 inline-flex items-center gap-x-2 leading-4',
          {
            'text-primary-500 ring-1 ring-primary-500': intent === 'primary',
            'text-stone-900 focus:ring-2 focus:ring-stone-500 focus:ring-offset-4 hover:bg-stone-50':
              intent === 'default',
          },
          className
        )}
      >
        <IconPhone className="w-4 h-4" />
        <span className="hidden xl:inline-block">{t('nav.talkToExpert')}</span>
      </Link>
    </>
  )
}
